import { createBroadcast } from "@/utils/broadcast"

import { ALL_SECTIONS, type Section } from "./tearOutSection.state"

const CHANNEL = "rt.tear-out.v1"

export interface TearOutMessage {
  v: 1
  type: "popIn"
  section: Section
}

const isSection = (value: unknown): value is Section =>
  typeof value === "string" &&
  (ALL_SECTIONS as readonly string[]).includes(value)

export const isTearOutMessage = (value: unknown): value is TearOutMessage => {
  if (typeof value !== "object" || value === null) {
    return false
  }

  const message = value as Partial<TearOutMessage>
  return (
    message.v === 1 && message.type === "popIn" && isSection(message.section)
  )
}

export const [tearOutMessages$, postTearOutMessage] = createBroadcast(
  CHANNEL,
  isTearOutMessage,
)
